module.exports = function cleanIdentifier(node, item, list) {
    // remove useless universal selector
    if (this.selector !== null && node.name === '*') {
        // remove when universal selector isn't last
        if (item.next && item.next.data.type !== 'Combinator') {
            list.remove(item);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/csso/lib/compressor/clean/Identifier.js
// module id = 2515
// module chunks = 0